import React, {Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import AdvancedQuotingSubpartItems from "../advancedQuotingSubpartItems";
import {
  getAvailableSteps, getFeatureGroupFromWizardGroup,
  getWizardStepIsDisabled
} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import AdvancedQuotingWizardGroups from "./advancedQuotingWizardGroups";
import {SQFT_FEATURES} from "../../../sqft/constants";
import {getSlabsFeatureGroup} from "../../../../misc/helpers";
import {isSameVisualizerWizard} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {getCommonVisualizerType} from "../../../../config";


const AdvancedQuotingWizard = (props) => {

  const {quoteIndex, quotes, cartItems, wizardList, allWizardsValues, intl, fabricatorData} = props;

  const currentQuoteCartItems = cartItems.filter(cartItem => cartItem.cartFeature && (cartItem.currentQuote === quoteIndex));
  let notFromWizardCartItems = currentQuoteCartItems.filter(cartItem => {
    return (!cartItem.fromWizardId || !cartItem.fromWizardStep) && cartItem.partId !== SQFT_FEATURES.slabs
  });
  let notFromWizardSlabCartItems = currentQuoteCartItems.filter(cartItem => {
    return (!cartItem.fromWizardId || !cartItem.fromWizardStep) && cartItem.partId === SQFT_FEATURES.slabs
  });

  const commonVisualizerType = quotes[quoteIndex] ? getCommonVisualizerType(quotes[quoteIndex].room) : getCommonVisualizerType();

  return (
    <Fragment>
      {wizardList.map(wizardItem => {

        if (fabricatorData.settings.allowVisualizerSwitching
          && !isSameVisualizerWizard(wizardItem, commonVisualizerType)) {
          return null
        }

        const wizardAllObject = allWizardsValues.find(wizardsSelectedObject => {
          return wizardsSelectedObject.quoteIndex === quoteIndex && (wizardsSelectedObject.wizardItemId === wizardItem.id)
            && isSameVisualizerWizard(wizardsSelectedObject, commonVisualizerType)
        }) || {quoteIndex, wizardItemId: wizardItem.id, visualizer: getCommonVisualizerType(), wizardSelectedValues: {}};

        const wizardSelectedValues = wizardAllObject.wizardSelectedValues;

        const wizardSteps = getAvailableSteps(wizardItem, wizardSelectedValues, true);

        // console.log("wizardSteps", wizardSteps);

        return wizardSteps.map((step) => {
          const stepDisabled = getWizardStepIsDisabled(step.stepIndex, wizardSelectedValues, wizardSteps);
          if (stepDisabled) {
            return null // this hides advanced quoting items!
          }
          const wizardGroup = wizardSelectedValues[step.stepIndex] && wizardSelectedValues[step.stepIndex].wizardGroup
            ? wizardSelectedValues[step.stepIndex].wizardGroup
            : step.stepGroups[0];
          if (!wizardGroup) {
            return null
          }
          if (step.stepGroups.length > 1) {
            return <AdvancedQuotingWizardGroups currentGroups={step.stepGroups}
                                                stepIndex={step.stepIndex}
                                                wizardAllObject={wizardAllObject}
                                                wizardGroup={wizardGroup}
                                                key={"wizValue" + wizardItem.id + quoteIndex + step.stepIndex}/>
          }
          const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
          if (!featureGroup) {
            return null
          }
          // return <MaterialsWizardFooterStep wizardSelectedValue={wizardSelectedValues[step.stepIndex]}
          //                                   wizardItem={wizardItem}
          //                                   isShoppingCart={isShoppingCart}
          //                                   stepDisabled={stepDisabled}
          //                                   currentWizardGroup={step.stepGroups[0]}
          //                                   stepIndex={step.stepIndex}
          //                                   />

          let advancedCartItems = currentQuoteCartItems.filter(cartItem => {
            return (featureGroup.partId === cartItem.partId) && (!cartItem.fromWizardId || cartItem.fromWizardId === wizardItem.id)
              && (!cartItem.fromWizardGroupId || cartItem.fromWizardGroupId === wizardGroup.id)
          });

          if (advancedCartItems.length) {
            if (notFromWizardCartItems.length) {
              notFromWizardCartItems = notFromWizardCartItems.filter(cItem => {
                return !advancedCartItems.some(cI => cI.id === cItem.id)
              })
            }
            if (notFromWizardSlabCartItems.length) {
              notFromWizardSlabCartItems = notFromWizardSlabCartItems.filter(cItem => {
                return !advancedCartItems.some(cI => cI.id === cItem.id)
              })
            }
          }

          return <AdvancedQuotingSubpartItems subPart={{part: featureGroup}}
                                              stepDisabled={stepDisabled}
                                              advancedCartItems={advancedCartItems}
                                              quoteIndex={quoteIndex}
                                              // wizard props
                                              stepIndex={step.stepIndex}
                                              wizardAllObject={wizardAllObject}
                                              wizardGroup={wizardGroup}
                                              // wizard props end
                                              key={"wizValue" + wizardItem.id + quoteIndex + step.stepIndex}/>
        })
      })}
      {notFromWizardCartItems.length ? (
        <AdvancedQuotingSubpartItems subPart={{part: {
            partId: "other_related_products",
            partName: intl.formatMessage({id: "assignPopup.otherFeatureGroupName"})}}}
                                     advancedCartItems={notFromWizardCartItems}
                                     quoteIndex={quoteIndex}/>
      ) : null}
      {notFromWizardSlabCartItems.length ? (
        <AdvancedQuotingSubpartItems subPart={getSlabsFeatureGroup()}
                                     advancedCartItems={notFromWizardSlabCartItems}
                                     quoteIndex={quoteIndex}/>
      ) : null}
    </Fragment>
  )
};

AdvancedQuotingWizard.propTypes = {
  quoteIndex: PropTypes.number.isRequired
}
const mapStateToProps = (store) => {
  const {wizardList, allWizardsValues} = store.wizardState;
  return {
    cartItems: store.cartState.cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    quotes: store.quotesState.quotes,
    showAllQuotesCartItemsList: store.cartState.showAllQuotesCartItemsList,
    fabricatorData: store.fabricatorState,
    wizardList,
    allWizardsValues,
  };
};

export default injectIntl(
  connect(mapStateToProps)(AdvancedQuotingWizard)
)
